import { IWaterlinkedInfo, WaterlinkedEndpoints } from '@scaleaq/sitecontrol-lib';

import { API_NAMES, CACHE_KEYS } from '@/constants';
import { useAuthApiDelete, useAuthApiPost, useAuthApiUpdate } from '@/dataAccess/rest/apiHooks';

export const useAddWaterlinkedDevice = (deviceIdentifier: string | undefined) => {
  return useAuthApiPost({
    baseApiRoute: API_NAMES.waterlinkedApi,
    route: WaterlinkedEndpoints.add,
    cacheKeys: [CACHE_KEYS.allWaterlinkedDevices],
    identifier: deviceIdentifier,
  });
};

export const useUpdateWaterlinkedDevice = (device: IWaterlinkedInfo | null | undefined) => {
  return useAuthApiUpdate({
    baseApiRoute: API_NAMES.waterlinkedApi,
    route: WaterlinkedEndpoints.update,
    id: '',
    cacheKeys: [CACHE_KEYS.allWaterlinkedDevices],
    identifier: device?.name,
  });
};
export const useRemoveWaterlinkedDevice = (device: IWaterlinkedInfo | null) => {
  return useAuthApiDelete({
    baseApiRoute: API_NAMES.waterlinkedApi,
    cacheKeys: [CACHE_KEYS.allWaterlinkedDevices],
    id: device?.id ?? '',
    identifier: device?.name,
    route: WaterlinkedEndpoints.remove,
  });
};
